import React from 'react';
import { SampleCarousel } from './SampleCarousel';
export function SolutionSection() {
  return <section className="py-6 px-4 bg-white" data-id="element-351">
      <div className="max-w-4xl mx-auto text-center" data-id="element-352">
        <h2 className="text-[20px] font-black mb-4 text-[#5B3FA0]" data-id="element-353">
          LA SOLUCIÓN: EFEMÉRIDES LISTAS SECUNDARIA
        </h2>

        <p className="text-xl md:text-2xl font-medium text-gray-700 mb-6 max-w-3xl mx-auto" data-id="element-354">
          Un recurso completo diseñado para que tengas actividades organizadas
          durante todo el año.
          <br data-id="element-355" />
          <br data-id="element-356" />
          Simplemente buscás la fecha que necesitás y la propuesta ya está lista
          para trabajar.
        </p>

        <div className="flex flex-col md:flex-row justify-center items-center gap-4 mb-6" data-id="element-357">
          <div className="bg-gray-50 p-4 rounded-xl shadow-sm w-full md:w-1/3 border border-gray-100" data-id="element-358">
            <div className="text-5xl mb-2" data-id="element-359">📅</div>
            <p className="text-xl font-bold" data-id="element-360">Buscás la efeméride</p>
          </div>

          <div className="hidden md:block text-3xl text-gray-300" data-id="element-361">➔</div>

          <div className="bg-gray-50 p-4 rounded-xl shadow-sm w-full md:w-1/3 border border-gray-100" data-id="element-362">
            <div className="text-5xl mb-2" data-id="element-363">📖</div>
            <p className="text-xl font-bold" data-id="element-364">Leés el material</p>
          </div>

          <div className="hidden md:block text-3xl text-gray-300" data-id="element-365">➔</div>

          <div className="bg-gray-50 p-4 rounded-xl shadow-sm w-full md:w-1/3 border border-gray-100" data-id="element-366">
            <div className="text-5xl mb-2" data-id="element-367">✏️</div>
            <p className="text-xl font-bold" data-id="element-368">Aplicás la actividad en clase</p>
          </div>
        </div>

        <SampleCarousel data-id="element-369" />

        <p className="text-2xl font-black text-gray-900" data-id="element-370">
          <span className="px-2 text-[#2E9E8F] bg-[#FFFFFF]" data-id="element-371">
            Sin perder tiempo. Sin empezar desde cero. Sin improvisar.
          </span>
        </p>
      </div>
    </section>;
}